import { AllocationViewActionIdentifierModel } from '../../models';

export class AllocationViewClearAction {
  public static readonly type = '[AllocationViewClearAction] ULI Clear';

  constructor(
    public payload: {
      identifier: AllocationViewActionIdentifierModel;
    },
  ) {}
}

export class AllocationViewClearActionSetInitialState {
  public static readonly type = '[AllocationViewClearAction] Set Initial State';
}
